module.exports = require("@ember/object/proxy");